var lang = {
    "en":{
        schedule: "Live schedule",
        upcoming: "Upcoming",
        subscribe: "Subscribe",
        subscribed: "Subscribed",
        liveTime: "Go live time",
        morecome: "More to come",
    },
    "ar":{
        schedule: "جدولة البثوث للمشاهير",
        upcoming: "البث المجدول",
        subscribe: "سجل",
        subscribed: "تم التسجيل",
        liveTime: "موعد البث المباشر",
        morecome: "المزيد قريبا",
    }
}

export {lang}


// WEBPACK FOOTER //
// ./src/language/kolupcoming.js